(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ws-flavor-swatches"] && !Shopify.designMode) return;
  try {
    (function () {
    var pickers = document.querySelectorAll('[data-ws-flavor-picker]');
    if (!pickers.length) return;

    pickers.forEach(function (picker) {
      var btns = picker.querySelectorAll('[data-ws-flavor-btn]');
      var selectedLabel = picker.querySelector('[data-ws-flavor-selected]');
      var optionPosition = picker.getAttribute('data-option-position');

      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = btn.getAttribute('data-option-value');

          /* Update active state on swatches */
          btns.forEach(function (b) {
            b.classList.remove('ws-flavor-swatches__btn--active');
            b.setAttribute('aria-checked', 'false');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('ws-flavor-swatches__btn--active');
          btn.setAttribute('aria-checked', 'true');
          btn.setAttribute('aria-pressed', 'true');

          /* Update selected label */
          if (selectedLabel) {
            selectedLabel.textContent = val;
          }

          /* Sync with native variant-picker radio buttons */
          var variantPicker = document.querySelector('variant-picker');
          if (!variantPicker) return;

          var fieldsets = variantPicker.querySelectorAll('fieldset');
          var targetFieldset = fieldsets[parseInt(optionPosition, 10) - 1];
          if (!targetFieldset) return;

          var radios = targetFieldset.querySelectorAll('input[type="radio"]');
          radios.forEach(function (radio) {
            if (radio.value === val) {
              radio.checked = true;
              radio.setAttribute('data-current-checked', 'true');
              radio.dispatchEvent(new Event('change', { bubbles: true }));
              radio.dispatchEvent(new Event('input', { bubbles: true }));
            } else {
              radio.setAttribute('data-current-checked', 'false');
            }
          });
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ws-format-cards"] && !Shopify.designMode) return;
  try {
    (function () {
    var pickers = document.querySelectorAll('[data-ws-format-picker]');
    if (!pickers.length) return;

    pickers.forEach(function (picker) {
      var btns = picker.querySelectorAll('[data-ws-format-btn]');
      var selectedLabel = picker.querySelector('[data-ws-format-selected]');
      var optionPosition = picker.getAttribute('data-option-position');

      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          var val = btn.getAttribute('data-option-value');

          /* Update active state on cards */
          btns.forEach(function (b) {
            b.classList.remove('ws-format-cards__btn--active');
            b.setAttribute('aria-checked', 'false');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('ws-format-cards__btn--active');
          btn.setAttribute('aria-checked', 'true');
          btn.setAttribute('aria-pressed', 'true');

          /* Update selected label */
          if (selectedLabel) {
            selectedLabel.textContent = val;
          }

          /* Sync with native variant-picker radio buttons */
          var variantPicker = document.querySelector('variant-picker');
          if (!variantPicker) return;

          var fieldsets = variantPicker.querySelectorAll('fieldset');
          var targetFieldset = fieldsets[parseInt(optionPosition, 10) - 1];
          if (!targetFieldset) return;

          var radios = targetFieldset.querySelectorAll('input[type="radio"]');
          radios.forEach(function (radio) {
            if (radio.value === val) {
              radio.checked = true;
              radio.setAttribute('data-current-checked', 'true');
              radio.dispatchEvent(new Event('change', { bubbles: true }));
              radio.dispatchEvent(new Event('input', { bubbles: true }));
            } else {
              radio.setAttribute('data-current-checked', 'false');
            }
          });
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ws-purchase-options"] && !Shopify.designMode) return;
  try {
    (function () {
    var roots = document.querySelectorAll('[data-ws-purchase]');
    if (!roots.length) return;

    function parseMoneyFormat(format) {
      return format || '';
    }

    function formatMoney(cents, format) {
      if (cents == null || isNaN(cents)) return '';
      var value = (cents / 100).toFixed(2);
      var parts = value.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var formatted = parts.join('.');
      if (format && format.indexOf('amount') !== -1) {
        return format.replace(/\{\{\s*amount[^}]*\}\}/g, formatted);
      }
      return '$' + formatted;
    }

    function findRechargeContainer() {
      var byClass = document.querySelector('[class*="recharge_subscriptions_subscription_widget"]');
      if (byClass) return byClass;
      var byHandle = document.querySelector('[data-block-handle*="recharge-subscriptions"]');
      if (byHandle) return byHandle;
      var byApp = document.querySelector('div[id*="recharge-subscription"]');
      return byApp;
    }

    function setRechargeOption(targetValue) {
      var container = findRechargeContainer();
      if (!container) return;
      var radios = container.querySelectorAll('input[type="radio"]');
      var match = null;
      for (var i = 0; i < radios.length; i++) {
        var r = radios[i];
        var v = (r.value || '').toLowerCase();
        var name = (r.name || '').toLowerCase();
        if (targetValue === 'subscription' && (v.indexOf('subscription') !== -1 || v.indexOf('subscribe') !== -1 || name.indexOf('selling_plan') !== -1)) {
          if (r.value && r.value !== '' && r.value !== '0') {
            match = r;
            break;
          }
        }
        if (targetValue === 'onetime' && (v.indexOf('onetime') !== -1 || v.indexOf('one-time') !== -1 || v === '0' || v === '')) {
          match = r;
          break;
        }
      }
      if (match && !match.checked) {
        match.checked = true;
        match.dispatchEvent(new Event('change', { bubbles: true }));
        match.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }

    roots.forEach(function (root) {
      var dataNode = root.querySelector('[data-ws-variants]');
      var variants = {};
      try {
        variants = JSON.parse(dataNode.textContent || '{}');
      } catch (e) {
        return;
      }

      var defaultPlanId = root.getAttribute('data-default-plan-id') || '';
      var moneyFormat = parseMoneyFormat(root.getAttribute('data-money-format'));

      var form = document.querySelector('product-form-component form');
      if (!form) return;

      var variantInput = form.querySelector('input[name="id"]');

      function ensureHiddenInput(name, initialValue) {
        var input = form.querySelector('input[type="hidden"][name="' + name + '"][data-ws-injected]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.setAttribute('data-ws-injected', '1');
          form.appendChild(input);
        }
        if (initialValue != null) input.value = initialValue;
        return input;
      }

      var sellingPlanInput = ensureHiddenInput('selling_plan', defaultPlanId);
      var quantityInput = ensureHiddenInput('quantity', '1');

      var rechargeContainer = findRechargeContainer();
      if (rechargeContainer) {
        rechargeContainer.setAttribute('data-ws-recharge-hidden', '');
      }

      var state = {
        purchase: 'subscription',
        qty: 1,
        variantId: (variantInput && variantInput.value) || (Object.keys(variants)[0] || '')
      };

      function currentVariant() {
        return variants[state.variantId] || variants[Object.keys(variants)[0]] || {};
      }

      function updateAtbButton() {
        var v = currentVariant();
        var unitPrice = state.purchase === 'subscription' && v.sub_price ? v.sub_price : v.price;
        if (!unitPrice) return;
        var total = unitPrice * state.qty;
        var btn = document.querySelector('product-form-component button[type="submit"]');
        if (!btn) return;
        var span = btn.querySelector('[data-ws-atb-text]');
        if (!span) {
          span = document.createElement('span');
          span.setAttribute('data-ws-atb-text', '');
          var existing = btn.querySelector('span:not([class*="loading"])') || btn;
          existing.textContent = '';
          existing.appendChild(span);
        }
        span.textContent = 'ADD TO CART - ' + formatMoney(total, moneyFormat);
      }

      function renderPrices() {
        var v = currentVariant();
        var compareEl = root.querySelector('[data-ws-compare]');
        var subPriceEl = root.querySelector('[data-ws-sub-price]');
        var oncePriceEl = root.querySelector('[data-ws-once-price]');
        var subPerEl = root.querySelector('[data-ws-sub-per-serving]');
        var oncePerEl = root.querySelector('[data-ws-once-per-serving]');
        var discountEl = root.querySelector('[data-ws-discount-pct]');
        var unitEls = root.querySelectorAll('[data-ws-unit]');

        if (compareEl) compareEl.textContent = formatMoney(v.sub_compare || v.price, moneyFormat);
        if (subPriceEl) subPriceEl.textContent = formatMoney(v.sub_price || v.price, moneyFormat);
        if (oncePriceEl) oncePriceEl.textContent = formatMoney(v.price, moneyFormat);

        if (v.servings && v.sub_price && subPerEl) {
          subPerEl.textContent = formatMoney(Math.round(v.sub_price / v.servings), moneyFormat);
        } else if (subPerEl) {
          subPerEl.textContent = '';
        }
        if (v.servings && v.price && oncePerEl) {
          oncePerEl.textContent = formatMoney(Math.round(v.price / v.servings), moneyFormat);
        } else if (oncePerEl) {
          oncePerEl.textContent = '';
        }

        if (discountEl && v.price && v.sub_price) {
          var pct = Math.round((v.price - v.sub_price) * 100 / v.price);
          discountEl.textContent = pct;
        }

        unitEls.forEach(function (el) {
          if (v.unit) el.textContent = v.unit;
        });

        if (v.unit) {
          var unitCap = v.unit.charAt(0).toUpperCase() + v.unit.slice(1);
          var qtyLabels = root.querySelectorAll('[data-ws-qty] [data-ws-qty-label]');
          qtyLabels.forEach(function (label) {
            var btn = label.closest('[data-ws-qty]');
            var n = parseInt(btn.getAttribute('data-ws-qty'), 10);
            label.textContent = unitCap + (n === 1 ? '' : 's');
          });
        }

        var compareWrap = root.querySelector('[data-ws-compare]');
        if (compareWrap) {
          compareWrap.style.display = (v.sub_price && v.sub_price < v.price) ? '' : 'none';
        }
      }

      function setPurchase(value) {
        state.purchase = value;
        var cards = root.querySelectorAll('[data-ws-purchase-card]');
        cards.forEach(function (card) {
          var isActive = card.getAttribute('data-ws-purchase-card') === value;
          card.classList.toggle('ws-purchase-options__card--active', isActive);
          var radio = card.querySelector('[data-ws-purchase-radio]');
          if (radio) radio.checked = isActive;
        });
        var qtyBlock = root.querySelector('.ws-purchase-options__qty');
        if (qtyBlock) qtyBlock.style.display = (value === 'subscription') ? '' : 'none';

        if (value === 'subscription') {
          var v = currentVariant();
          sellingPlanInput.value = v.sub_plan_id || defaultPlanId;
        } else {
          sellingPlanInput.value = '';
          state.qty = 1;
          var qtyBtns = root.querySelectorAll('[data-ws-qty]');
          qtyBtns.forEach(function (b) {
            var isActive = parseInt(b.getAttribute('data-ws-qty'), 10) === 1;
            b.classList.toggle('ws-purchase-options__qty-btn--active', isActive);
            b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
        }
        quantityInput.value = state.qty;
        setRechargeOption(value);
        updateAtbButton();
      }

      function setQty(n) {
        state.qty = n;
        var btns = root.querySelectorAll('[data-ws-qty]');
        btns.forEach(function (b) {
          var isActive = parseInt(b.getAttribute('data-ws-qty'), 10) === n;
          b.classList.toggle('ws-purchase-options__qty-btn--active', isActive);
          b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        quantityInput.value = n;
        updateAtbButton();
      }

      function applyVariantId(newId) {
        if (!newId || newId === state.variantId) return;
        state.variantId = newId;
        if (variantInput) variantInput.value = newId;
        renderPrices();
        if (state.purchase === 'subscription') {
          var v = currentVariant();
          sellingPlanInput.value = v.sub_plan_id || defaultPlanId;
        }
        updateAtbButton();
      }

      function syncFromVariantInput() {
        if (!variantInput) return;
        applyVariantId(variantInput.value);
      }

      function findVariantByOptions(opts) {
        for (var id in variants) {
          var v = variants[id];
          if (!v.options) continue;
          var ok = true;
          for (var i = 0; i < opts.length; i++) {
            if (opts[i] != null && v.options[i] !== opts[i]) { ok = false; break; }
          }
          if (ok) return id;
        }
        return null;
      }

      function syncFromOptionPickers() {
        var flavorPicker = document.querySelector('[data-ws-flavor-picker]');
        var formatPicker = document.querySelector('[data-ws-format-picker]');
        var opts = [];
        if (flavorPicker) {
          var fp = parseInt(flavorPicker.getAttribute('data-option-position'), 10);
          var fb = flavorPicker.querySelector('[data-ws-flavor-btn].ws-flavor-swatches__btn--active');
          if (!isNaN(fp) && fb) opts[fp - 1] = fb.getAttribute('data-option-value');
        }
        if (formatPicker) {
          var gp = parseInt(formatPicker.getAttribute('data-option-position'), 10);
          var gb = formatPicker.querySelector('[data-ws-format-btn].ws-format-cards__btn--active');
          if (!isNaN(gp) && gb) opts[gp - 1] = gb.getAttribute('data-option-value');
        }
        var newId = findVariantByOptions(opts);
        if (newId) applyVariantId(newId);
      }

      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-ws-flavor-btn], [data-ws-format-btn]')) {
          setTimeout(syncFromOptionPickers, 50);
        }
      });

      root.addEventListener('click', function (e) {
        var qtyBtn = e.target.closest('[data-ws-qty]');
        if (qtyBtn) {
          e.preventDefault();
          var n = parseInt(qtyBtn.getAttribute('data-ws-qty'), 10);
          if (!isNaN(n)) setQty(n);
          return;
        }
        var card = e.target.closest('[data-ws-purchase-card]');
        if (card) {
          var value = card.getAttribute('data-ws-purchase-card');
          setPurchase(value);
        }
      });

      var variantPicker = document.querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('change', function () {
          setTimeout(syncFromVariantInput, 0);
        });
      }
      document.addEventListener('variant:change', syncFromVariantInput);
      document.addEventListener('product:variant-change', syncFromVariantInput);

      if (variantInput) {
        var observer = new MutationObserver(syncFromVariantInput);
        observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
      }

      renderPrices();
      setPurchase('subscription');
      setQty(1);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
